"use client";

export type ImmigrationStatusOptionGroup = {
  label: string;
  options: Array<{ value: string; label?: string }>;
};

/**
 * Canonical set of immigration status options. Keep in sync with the existing
 * `ApplicantInfoEditor` status list.
 */
export const IMMIGRATION_STATUS_OPTION_GROUPS: ImmigrationStatusOptionGroup[] =
  [
    {
      label: "U.S. Citizen & Permanent Resident",
      options: [
        { value: "U.S. Citizen" },
        { value: "LPR (Lawful Permanent Resident)" }
      ]
    },
    {
      label: "Humanitarian Statuses",
      options: [
        { value: "Asylee" },
        { value: "Refugee" },
        { value: "TPS" },
        { value: "DACA" },
        { value: "VAWA" },
        { value: "SIJS" },
        { value: "U Visa" },
        { value: "T Visa" },
        { value: "Withholding of Removal" },
        { value: "Parole – Humanitarian or Advance" },
        { value: "Deferred Enforced Departure (DED)" },
        { value: "EWI" }
      ]
    },
    {
      label: "Nonimmigrant Visas",
      options: [
        { value: "B-1/B-2" },
        { value: "F-1" },
        { value: "F-2" },
        { value: "M-1" },
        { value: "M-2" },
        { value: "J-1" },
        { value: "J-2" },
        { value: "H-1B" },
        { value: "H-1B1" },
        { value: "H-4" },
        { value: "H-2A" },
        { value: "H-2B" },
        { value: "L-1A/L-1B" },
        { value: "L-2" },
        { value: "O-1A" },
        { value: "O-1B" },
        { value: "O-2" },
        { value: "O-3" },
        { value: "P" },
        { value: "R-1" },
        { value: "E-1" },
        { value: "E-2" },
        { value: "E-3" },
        { value: "TN" },
        { value: "TD" },
        { value: "K-1" },
        { value: "K-3" },
        { value: "A/G/NATO" },
        { value: "Other Nonimmigrant Visa" }
      ]
    },
    {
      label: "Adjustment & Transitional Statuses",
      options: [
        { value: "Pending AOS" },
        { value: "Pending Asylum" },
        { value: "Parole-in-Place" },
        { value: "D/S" }
      ]
    },
    {
      label: "No Current Status",
      options: [
        {
          value: "No status",
          label: "No status (out of status or never admitted)"
        }
      ]
    }
  ];

export const IMMIGRATION_STATUS_OPTIONS_FLAT =
  IMMIGRATION_STATUS_OPTION_GROUPS.flatMap((group) =>
    group.options.map((opt) => opt.value)
  );
